import { GeometryTypes } from 'src/app/shared/common/utility/geometry-utils';

export type AttributeSymbologyOptions = {
    id: string;
    name: string;
    label: string;
    type: string; // 'choice' or 'codedchoice'.
};

export type SymbologyOverrideChoice = {
    id?: string;
    choiceUuid?: string;
    choiceField: string;
    choiceValue: string;
    choiceDisplayValue?: string;
    lineColor: number;
    fillColor: number;
    outlineColor: number;
    color: number;
};

export type StyleOverride = {
    lineColor: number;
    fillColor: number;
};

export type SymbolOverride = {
    fillColor: number;
    outlineColor: number;
    color: number;
};

export type SymbolOverrideDTO = {
    id: string;
    filter: string;
    styleOverride: StyleOverride;
    symbolOverride: SymbolOverride;
};

export class SymbologyOverride {
    id: string;
    styleId: string;
    filter: string;
    styleOverride: StyleOverride;
    symbolOverride: SymbolOverride;

    static fromDTO(dto: SymbolOverrideDTO): SymbologyOverride {
        let symbologyOverride = new SymbologyOverride();

        symbologyOverride.id = dto.id;
        symbologyOverride.styleId = dto.id;
        symbologyOverride.filter = dto.filter;
        symbologyOverride.styleOverride = dto.styleOverride;
        symbologyOverride.symbolOverride = dto.symbolOverride;

        return symbologyOverride;
    }
}

export enum LayerSymbologyType {
    GEOMETRIC = 'Geometric',
    FEATURE = 'Feature',
    CUSTOMIZABLE = 'Customizable'
}

export type LayerSymbolTypes = {
    id: number;
    name: LayerSymbologyType;
    label: string;
};

export enum LineStyle {
    SOLID = 'SOLID',
    DASHED = 'DASHED',
    DOTTED = 'DOTTED'
}

export class LineStyleOptions {
    id: number;
    name: LineStyle;
    label: string;
    iconClass: string;
}

export type SymbolShapeDefinition = {
    // Symbol shape definitions are all the available shapes that can be used to create a symbol.
    id: string;
    uuid: string;
    type: LayerSymbologyType;
    symbolName: string;
    geometryType: GeometryTypes;
    svgImage: string;
    imageClass: string;
    createdUtc: string;
    updatedUtc: string;
};

export type SymbolShapeOptions = {
    id: string;
    name: string;
    label: string;
    iconClass: string;
};

export class StyleSymbol {
    id: string;
    symbolDefinitionId: string;
    symbolDefinitionUuid: string;
    symbolName: string;
    svgImage: string;
    type: LayerSymbologyType = LayerSymbologyType.GEOMETRIC;
    fillColor: number;
    outlineColor: number;
    text: string = '';
    color: number; // Text color for customizable symbols.
}
